"use strict";

import _ from 'lodash';
import moment from "moment";

const today = moment();

export default {
    state: {
        tillResource: {},
        barcodesResource: {},
        layout: {},
        tillCarts: [],
        customer: {
            first_name: '',
            last_name: '',
            address_1: '',
            address_2: '',
            address_3: '',
            city: '',
            county: '',
            postcode: '',
            country: '826',
            email: '',
            telephone: '',
        },
        tillModalTitle: 'Phone Payment',
        backorders: {},
        productDetail: {
            product: {},
            help: {},
            keywords: [],
            barcodes: []
        },
        returnsData: {
            customerName: '',
            customerContact: '',
            notes: ''
        },
        backorderName: 'Holding',
        selectedBackorder: {},
        showList: false,
        linkNextBarcode: false,
        paidAmount: 0,
        preOrder: {
            name: '',
            tel: '',
            time: '',
            day: today
        }
    },

    getters: {
        tillResource: state => {
            return state.tillResource;
        },

        barcodesResource: state => {
            return state.barcodesResource;
        },

        layout: state => {
            return state.layout;
        },

        tillCarts: state => {
            return state.tillCarts;
        },

        customer: state => {
            return state.customer;
        },

        tillModalTitle: state => {
            return state.tillModalTitle;
        },

        backorders: state => {
            return state.backorders;
        },

        productDetail: state => {
            return state.productDetail;
        },

        backorderName: state => {
            return state.backorderName;
        },

        selectedBackorder: state => {
            return state.selectedBackorder;
        },

        showList: state => {
            return state.showList
        },

        linkNextBarcode: state => {
            return state.linkNextBarcode;
        },

        returnsCustomerName: state => {
            return state.returnsData.customerName;
        },

        returnsCustomerContact: state => {
            return state.returnsData.customerContact;
        },

        returnsCustomerNotes: state => {
            return state.returnsData.notes
        },

        returnsData: state => {
            return state.returnsData;
        },

        paidAmount: state => {
            return state.paidAmount
        },

        preOrder: state => {
            return state.preOrder;
        }
    },

    mutations: {
        layout: ( state, layout ) => {
            state.layout = layout;
        },

        tillResource: ( state, tillResource ) => {
            state.tillResource = tillResource;
        },

        barcodesResource: ( state, barcodesResource ) => {
            state.barcodesResource = barcodesResource;
        },

        tillCarts: ( state, carts ) => {
            state.tillCarts = carts;
        },

        customer: ( state, customer ) => {
            state.customer = customer;
        },

        tillModalTitle: ( state, title ) => {
            state.tillModalTitle = title;
        },

        backorders: ( state, backorders ) => {
            state.backorders = backorders;
        },

        productDetail: ( state, detail ) => {
            state.productDetail = detail;
        },

        productDetailKeywords: ( state, keywords ) => {
            state.productDetail.keywords = keywords;
        },

        productDetailBarcodes: ( state, barcodes ) => {
            state.productDetail.barcodes = barcodes;
        },

        updateTillCart: ( state, newCart ) => {
            _.$update( state.tillCarts, { till_id: newCart.till_id }, newCart );
        },

        backorderName: ( state, name ) => {
            state.backorderName = name;
        },

        selectedBackorder: ( state, backorderId ) => {
            state.selectedBackorder = _.find( state.backorders, { id: backorderId } );
        },

        toggleList: ( state, newState ) => {
            if ( typeof newState !== 'undefined' ) {
                state.showList = newState;
            } else {
                state.showList = !state.showList;
            }
        },

        linkNextBarcode: ( state, nextBarcode ) => {
            state.linkNextBarcode = nextBarcode;
        },

        updateReturnsName: ( state, name ) => {
            state.returnsData.customerName = name;
        },

        updateReturnsContact: ( state, contact ) => {
            state.returnsData.customerContact = contact;
        },

        updateReturnsNote: ( state, notes ) => {
            state.returnsData.notes = notes;
        },

        resetReturns: ( state ) => {
            state.returnsData = {
                customerName: '',
                customerContact: '',
                notes: ''
            }
        },

        paidAmount: ( state, newAmount ) => {
            state.paidAmount = parseInt( newAmount );
        }
    },

    actions: {
        setupDrawer( { state, getters } ) {
            return new Promise( ( resolve, reject ) => {
                getters.tillResource.drawer().then(
                    ( carts ) => {
                        state.tillCarts = carts.body;
                        resolve( carts.body );
                    },
                    ( error ) => {
                        reject( 'Problem setting up cash drawer' );
                    }
                );
            } );
        },

        resetPreOrder( {state } ) {
            state.preOrder = {
                name: '',
                tel: '',
                time: '',
                day: 2
            }
        },

        getLayout: ( { getters, commit } ) => {
            getters.tillResource.layout().then(
                ( layout ) => {
                    commit( 'layout', layout.body );
                }
            )
        },

        printList: ( { state }, cartId ) => {
            state.tillResource.print( { 'cartId': cartId } ).then(
                ( response ) => {
                    return true;
                }
            )
        },

        createPhoneOrder: ( { getters, commit }, salesDetails ) => {
            let items = getters.currentCart.items;

           _.forEach(
               items,
                function ( item ) {
                    delete item.order_type;
                    delete item.line_total;
                    delete item.product;
                    item.cost = item.item_cost * 100;
                }
            );

            let postData = {
                'order': {
                    'origin': 'Website'
                },
                'customer': salesDetails.customer,
                'items': items
            };

            return new Promise( ( resolve, reject ) => {
                getters.salesResource.save( postData ).then(
                    ( order ) => {
                        commit( 'currentOrder', order.data );
                        resolve( order.data );
                    }
                ).catch( reject );
            } );
        },

        getBackorders: ( { getters, commit } ) => {
            return new Promise( ( resolve, reject ) => {
                getters.salesResource.backorders().then(
                    ( backorders ) => {
                        commit( 'backorders', backorders.data );
                        commit( 'selectedBackorder', backorders.data[ 0 ].id );
                        resolve( backorders.data );
                    }
                ).catch( reject );
            } );
        },

        placeBackorder( { state, getters }, data ) {
            data.cartId = getters.currentCart.id;
            data.name = getters.backorderName;
            data.items = getters.selectedCartItems;
            return new Promise( ( resolve, reject ) => {
                getters.salesResource.placeBackorder( data ).then(
                    sale => {
                        resolve( sale.data );
                    }
                ).catch( reject );
            } );
        },

        barcodeEntered: ( { getters, commit }, barcode ) => {
            return new Promise( ( resolve, reject ) => {
                getters.barcodesResource.product( { barcode: barcode } ).then(
                    response => {
                        resolve( response.data );
                        //add to current cart
                    },

                    error => {
                        // this is probably where I'll handle the set up to add a new barcode
                        reject( 'Barcode not found' );
                    }
                )
            } );
        },

        loadKitToTill: ( { getters, commit }, productSlug ) => {
            return new Promise( ( resolve, reject ) => {
                getters.tillResource.loadKit( { cartId: getters.currentCart.id, productSlug: productSlug } ).then(
                    ( response ) => {
                        resolve( response.data );
                    },
                    ( error ) => {
                        reject( 'Problem loading kit' );
                    }
                )
            } )
        },

        placeReturn: ( { getters, commit }, data ) => {
            return new Promise( ( resolve, reject ) => {

                let sendData = _.merge( getters.returnsData, { cartId: getters.currentCart.id } );
                console.log( 'sendData', sendData );
                getters.tillResource.createReturn( sendData ).then(
                    ( response ) => {
                        commit( 'resetReturns' );
                        resolve( response.data )
                    },
                    ( error ) => {
                        reject( 'Problem placing return' );
                    }
                )
            } ).catch( console.log )
        },

        setCart( { commit, state }, cartId = null ) {
            return new Promise( ( resolve, reject ) => {
                state.cartId = ( cartId === null ) ? 1 : cartId;
                state.tillResource.get( {
                    cartId: state.cartId
                } ).then(
                    ( cart ) => {
                        commit( 'clearSelectedCartItems' );
                        commit( 'setCart', cart.body );
                        resolve( cart.body );
                    },
                    ( error ) => {
                        reject( 'Problem setting the cart' );
                    }
                );
            } );
        },
    }
}
